import { render } from "./modal-livraison.vue?vue&type=template&id=56bd0e2d"
import script from "./modal-livraison.vue?vue&type=script&lang=js"
export * from "./modal-livraison.vue?vue&type=script&lang=js"

import "./modal-livraison.vue?vue&type=style&index=0&id=56bd0e2d&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__